import { LinkedPageKind } from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'

import { routePaths } from '~/routes/routePaths'

export const isBiddingApprovalLinkedPage = (
  kind: LinkedPageKind | undefined,
): boolean =>
  kind === LinkedPageKind.BIDDING_SPOT ||
  kind === LinkedPageKind.BIDDING_INTRADAY

export const workflowTemplateEditHref = (templateId: string): string =>
  `${routePaths.adminWorkflowTemplates.path}?edit=${encodeURIComponent(templateId)}`

export const approvalSettingsHref = (
  kind: LinkedPageKind | undefined,
  workflowTemplateId: string,
): string =>
  isBiddingApprovalLinkedPage(kind)
    ? routePaths.adminApprovalFlow.path
    : workflowTemplateEditHref(workflowTemplateId)
